import { apiRequest } from './api';

export function getFavorites() {
  return apiRequest('/favorites');
}

export function isFavorite(articleId) {
  return apiRequest(
    `/favorites/check/${encodeURIComponent(articleId)}`,
  );
}

export function addFavorite(articleId) {
  return apiRequest(
    `/favorites/${encodeURIComponent(articleId)}`,
    { method: 'POST' },
  );
}

export function removeFavorite(articleId) {
  return apiRequest(
    `/favorites/${encodeURIComponent(articleId)}`,
    { method: 'DELETE' },
  );
}
